import AsideLeft from '../asideleft/AsideLeft'
import Main from '../main/Main'
import AsideRight from '../asideright/AsideRight'

import './main.css';
import UserAppContext from '../../hook/UserAppContext';

const MainContent = () => {

      const {user} = UserAppContext()

      if(user.length === 0) return

      return (
            <div className="main_content">
                  <AsideLeft />
                  <Main />
                  <AsideRight />
            </div>
      )
}

export default MainContent